/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LiquidityProvider } from './liquidityProvider';
import { DirectLpDescription } from './directLpDescription';

export interface MarketMakingSettingsDto {
  bridgeLp?: LiquidityProvider;
  directLpDescriptions?: Array<DirectLpDescription>;
}
